import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Globals, Constants, Permissions } from 'utils';
import Header from './header';
import $ from 'jquery';
import { Logo, LogoIcon, AssistantImage, AssistantMiniImage } from 'assets/img';
import { ArrowUp, ArrowBottom, Menu as MenuIcons, MenuIcon, MenuOpenIcon, MenuCloseIcon, CloseIcon, SendIcon, LoadingGif } from 'assets/icons';
import { HeaderTitle, Input } from 'components';
import { SupportService } from 'services';

interface MenuItem {
	name: string;
	path: string;
	submenu?: MenuItem[];
	icon?: string;
	permission?: string;
	onClick?: () => void;
	iconActive?: string;
	code: string;
	isLogout?: boolean;
}

class Menu extends React.Component<any> {

	messagesEnd: any = null;

	state: any = {
		leftOpen: this.props.sidebar,
		openResponsive: false,
		items: [
			{ name: 'Usuarios', path: '/admin/users', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
			{ name: 'Planes', path: '/admin/plans/consultations', icon: MenuIcons.Menu3, iconActive: MenuIcons.Menu3 },
			{ name: 'Conversaciones', path: '/admin/reports/consultations', icon: MenuIcons.Menu5, iconActive: MenuIcons.Menu5 },
			{ name: 'Ventas', path: '/admin/reports/sales', icon: MenuIcons.Menu6, iconActive: MenuIcons.Menu6 },
			{ name: 'Citas', path: '/admin/reports/appointments', icon: MenuIcons.Menu10, iconActive: MenuIcons.Menu10 },
			{ name: 'Pagos', path: '/admin/reports/payments', icon: MenuIcons.Menu7, iconActive: MenuIcons.Menu7 },
			{ name: 'Referidos', path: '/admin/referrals', icon: MenuIcons.Menu9, iconActive: MenuIcons.Menu9 }
		],
		items_client: [
			{ name: 'Inicio', path: '/client/home', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
			{ name: 'Accionar del Agente', path: '/client/agent', icon: MenuIcons.Menu2, iconActive: MenuIcons.Menu2 },
			{ name: 'Conocimiento', path: '/client/information', icon: MenuIcons.Menu5, iconActive: MenuIcons.Menu5 },
			{ name: 'Conversaciones', path: '/client/reports/consultations', icon: MenuIcons.Menu3, iconActive: MenuIcons.Menu3 },
			{ name: 'Conexión de Canales', path: '/client/api', icon: MenuIcons.Menu4, iconActive: MenuIcons.Menu4 },
			{ name: 'Ventas', path: '/client/reports/sales', icon: MenuIcons.Menu6, iconActive: MenuIcons.Menu6 },
			{ name: 'Citas', path: '/client/reports/appointments', icon: MenuIcons.Menu10, iconActive: MenuIcons.Menu10 },
			{ name: 'Probar Agente', path: '/client/reports/test', icon: MenuIcons.Menu8, iconActive: MenuIcons.Menu8 },
			{ name: 'Referidos', path: '/client/reports/referrals', icon: MenuIcons.Menu9, iconActive: MenuIcons.Menu9 }
		],
		form: {
			message: ''
		},
		visible_chat: false,
		consultations: [],
		waiting_response: false,
		loading: true,
		isMobile: window.matchMedia('(max-width: 768px)').matches
	}

	componentDidMount() {
		this.load();

		window.matchMedia('(max-width: 768px)').addListener((e: any) => {
			this.setState({ isMobile: e.matches });
		});
	}

	load = async () => {
		await this.setState({
			loading: true
		});
		const res: any = await SupportService.get({
			withoutLoading: true
		});
		if (res.result) {
			this.setState({
				consultations: res.consultations || [],
				loading: false
			},() => {
				this.scrollToBottom();
			});
		}
	}

	toggleSidebar = () => {
	    let key: any = `leftOpen`;
	    // @ts-ignore
	    this.setState({ [key]: !this.state[key] },() => {
	    	this.props.dispatch({
	    		type: 'SET_SIDEBAR',
	    		payload: this.state.leftOpen
	    	});
	    });
	}

	checkActive = (value: string, current: string) => {
		return current.includes(value);
	}

	changeMenu = (item: MenuItem) => {
		if (item.submenu && !this.state.leftOpen) {
			this.toggleSidebar();
		}
	}

	checkPermission = (item: any) => {
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN) {
			return true;
		}
		const permissions = this.props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];
		if (Array.isArray(item.permission)) {
			let _continue = false;
			item.permission.forEach((i: any) => {
				if (permissions.indexOf(i) != -1) {
					_continue = true;
				}
			});
			return _continue;
		}
		else {
			return permissions.indexOf(item.permission) != -1;
		}		
	}

	closeNavbar = () => {
		// @ts-ignore
		$('#collapsibleNavbar').collapse('hide');
	}

	toggleResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	closeResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	openChat = (e: any) => {
		e.preventDefault();
		this.setState({
			visible_chat: true
		},() => {
			this.scrollToBottom();
		});
	}

	closeChat = (e: any) => {
		e.preventDefault();
		this.setState({
			visible_chat: false
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	keydown = (e: any) => {
	  if (e.nativeEvent.keyCode == 13) {
	  	e.preventDefault();
	  	this.send(e);
	  }
	}

	send = async (e: any) => {
		e.preventDefault();
		if (!this.state.waiting_response && this.state.form.message) {
			const message = this.state.form.message;
			let consultations: any = [...this.state.consultations];
			consultations.push({
				question: message
			});
			await this.setState({
				consultations,
				waiting_response: true,
				form: {
					...this.state.form,
					message: ''
				}
			},() => this.scrollToBottom());
			const res: any = await SupportService.send({
				message,
				withoutLoading: true
			});
			consultations.pop();
			consultations.push(res.consultation);
			this.setState({
				consultations,
				waiting_response: false
			},() => this.scrollToBottom());
		}
	}

	scrollToBottom = () => {
		try {
			this.messagesEnd.scrollTo({
				behavior: 'smooth',
				top: this.messagesEnd.scrollHeight
			});
		}
		catch(e) {}
	}

	render() {
		let leftOpen = !this.props.isAuth && this.state.leftOpen ? "open" : (this.state.isMobile ? "open" : "closed");
		let items = [];
		const { visible_chat } = this.state;

		if (this.props.user) {
			switch(this.props.user?.level_id) {
				case Constants.LEVELS.ADMIN:
					items = this.state.items;
				break;

				case Constants.LEVELS.MODERATOR:
					items = this.state.items;
				break;

				case Constants.LEVELS.CLIENT:
					items = this.state.items_client;
				break;
			}
		}

		return (
			<React.Fragment>
				{/*{
					items.length > 0 && (
						<nav className="navbar navbar-expand-lg bg-dark navbar-dark fixed-top justify-content-start">
						  <button className="navbar-toggler" type="button" onClick={ this.toggleResponsive }>
						    <img src={ MenuIcon } />
						  </button>
					    </nav>
					)
				}*/}

				<div id="left" className={ leftOpen }>
					<div className={`sidebar ${ leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '') }`}>
						<div className={ `shadow-close ${ this.state.openResponsive ? 'open' : '' }` } onClick={ this.closeResponsive }></div>
						<div className="container-menu">
							<div className={ `menu ${ leftOpen }` }>
								<div className="container-scroll">
									{/*<div className="container-logo">
										<img src={ this.state.leftOpen ? Logo : LogoIcon } className={ this.state.leftOpen ? '' : 'logo-responsive' } />
									</div>*/}
									<button className={ `navbar-toggler navbar-toggler-menu ${ leftOpen }` } type="button" onClick={ () => {
										this.toggleSidebar();
									} }>
									    <img src={ MenuIcon } />
									</button>
									<ul className={ leftOpen }>
										{ items.map((i: MenuItem,index: number) => {
											return (
												<React.Fragment key={ index }>
													{
														(!i.permission || this.checkPermission(i)) && (
															<li className={ `nav-item ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																<Link to={ i.path } className={ `${ i.submenu && i.submenu.length > 0 ? 'contain-submenu' : '' }` } onClick={ (e: any) => {
																	if (i.onClick) {
																		e.preventDefault();
																		i.onClick();
																	}
																	else {
																		if (i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) && this.props.open_menu) {
																			this.props.dispatch({
																				type: 'SET_OPEN_MENU',
																				payload: false
																			});
																			e.preventDefault();
																		}
																		else {
																			this.props.dispatch({
																				type: 'SET_OPEN_MENU',
																				payload: true
																			});
																			this.changeMenu(i);
																			this.closeResponsive();
																		}
																	}																	
																} }>
																	<div className={ `container-icon-menu ${ leftOpen } ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																		{
																			i.icon && (
																				<img src={ this.checkActive(i.path,this.props.history.location.pathname) ? i.iconActive : i.icon } />
																			)
																		}
																	</div>												
																	<span className={ leftOpen }>
																		{ i.name }
																		{/*{
																			i.submenu && i.submenu.length > 0 && (
																				<React.Fragment>
																					{
																						this.checkActive(i.path,this.props.history.location.pathname) ? (
																							<img className="arrow-drop" src={ this.props.open_menu ? ArrowUp : ArrowBottom } />
																						) : (
																							<img className="arrow-drop" src={ ArrowBottom } />
																						)
																					}
																				</React.Fragment>
																			)
																		}*/}
																	</span>
																</Link>
																{
																	this.props.open_menu && (
																		<div className={ `${ i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) ? 'container-submenu' : '' }` }>
																			{
																				leftOpen != 'closed' && this.checkActive(i.path,this.props.history.location.pathname) && i.submenu && i.submenu.map((item: MenuItem,index: number) => {
																					if (!item.permission || this.checkPermission(item)) {
																						return (
																							<li className={ 'nav-item item-submenu ' + (this.props.history.location.pathname == item.path ? 'active' : '') }>
																								<Link to={ item.path } className="submenu">
																									{
																										item.icon && (
																											<img src={ item.icon } />
																										)
																									}
																									{ item.name }
																								</Link>
																							</li>
																						)
																					}
																				})
																			}
																		</div>
																	)
																}
															</li>
														)
													}												
												</React.Fragment>
											)
										}) }
									</ul>
								</div>
							</div>
						</div>
						<div className={ `container-router ${ leftOpen }` }>
							<Header className={ leftOpen + ' ' + (items.length > 0 && 'header-responsive') } toggleSidebar={ () => this.toggleSidebar() } toggleResponsive={ () => this.toggleResponsive() } />
							{
								!this.props.header?.hide && (
									<HeaderTitle />
								)
							}
							<div className={ `container-padding-router ${ items.length > 0 && 'container-responsive' }` }>{ this.props.children }</div>
						</div>
					</div>
				</div>

				{
					!visible_chat && (
						<a href="#" className="assistant-container" onClick={ (e: any) => this.openChat(e) }>
							<img src={ AssistantImage } />
						</a>
					)
				}
				
				{
					visible_chat && (
						<div className="chat-container">
							<div className="chat-header">
								<img src={ AssistantMiniImage } />
								<div style={{ flex: 1 }}>
									<p>Asistente</p>
								</div>
								<a href="#" onClick={ (e: any) => this.closeChat(e) }>
									<img src={ CloseIcon } className="close" />
								</a>
							</div>
							<div className="chat-content" ref={ (el) => { this.messagesEnd = el; } }>
								{
									this.state.consultations.map((item: any) => {
										return (
											<>
												{
													item.question && (
														<div className="item-message">
															<div style={{ width: '100%' }}>
																<p className="message">{ item.question }</p>
															</div>
														</div>
													)
												}
												{
													item.response && (
														<div className="item-message item-left">
															<div style={{ width: '100%' }}>
																<p className="message">{ item.response }</p>
															</div>
														</div>
													)
												}
											</>
										)
									})
								}
							</div>
							<div className="send-container">
								<Input
									value={ this.state.form.message }
									name="message"
									placeholder="Escribir"
									onKeyDown={ (e: any) => this.keydown(e) }
									onChange={ (e: any) => this.change(e) } />
								{
									this.state.waiting_response ? (
										<img src={ LoadingGif } />
									) : (
										<a href="#" onClick={ (e: any) => this.send(e) }>
											<img src={ SendIcon } />
										</a>
									)
								}
							</div>
						</div>
					)
				}
			</React.Fragment>
		)
	}
}

export default connect((state: any) => {
	return {
		user: state.user,
		open_menu: state.open_menu,
		sidebar: state.sidebar,
		header: state.header
	}
})(Menu);